module.exports = class BulkTransferInfoCtrl
  constructor: ->
    'ngInject'
